<div class="container">
  <div class="header">
    <div class="logo-section">
      <img src="assets/img/paacap-logo-1.png" alt="Logo" class="logo">
      <div class="app-info">
        <h5 class="app-name">PAACAP</h5>
        <p class="app-subname">Patient Assistance Program</p>
      </div>
    </div>
    <span class="version">{{ version }}</span>
  </div>
  <div class="division">
    <h6>MAIN MENU</h6>
  </div>
  <div class="route-container main-container">
    <mat-accordion>
      @for (mainRoute of routesData; track mainRoute.path) {
        <!-- Single Route -->
        @if (isSingleRoute(mainRoute)) {
          <mat-nav-list>
            <mat-list-item
              [routerLink]="mainRoute.path"
              routerLinkActive="active-link"
              class="menu-item single-route"
              (click)="toggleDrawer()"
            >
              <div class="item-container">
                <mat-icon>{{ mainRoute.metaData.navIcon }}</mat-icon>
                <h6 class="route-name">{{ mainRoute.metaData.navName }}</h6>
              </div>
            </mat-list-item>
          </mat-nav-list>
        }

        <!-- Grouped Route -->
        @if (isGroupedRoute(mainRoute)) {
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title class="menu-item">
                <div class="item-container">
                  <mat-icon>{{ mainRoute.metaData.navIcon }}</mat-icon>
                  <h6 class="route-name">{{ mainRoute.metaData.navName }}</h6>
                </div>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <mat-nav-list>
              @for (childRoute of mainRoute.children; track childRoute.path) {
                <mat-list-item
                  class="menu-item"
                  [routerLink]="mainRoute.path + '/' + childRoute.path"
                  routerLinkActive="active-link"
                  (click)="toggleDrawer()"
                >
                  <div class="item-container-second-child">
                    <h6 class="route-name">{{ childRoute.metaData.navName }}</h6>
                  </div>
                </mat-list-item>
              }
            </mat-nav-list>
          </mat-expansion-panel>
        }

        <!-- Multi-Grouped Route -->
        @if (isMultiGroupedRoute(mainRoute)) {
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title class="menu-item">
                <div class="item-container">
                  <mat-icon>{{ mainRoute.metaData.navIcon }}</mat-icon>
                  <h6 class="route-name">{{ mainRoute.metaData.navName }}</h6>
                </div>
              </mat-panel-title>
            </mat-expansion-panel-header>

            @for (innerMainRoute of mainRoute.children; track innerMainRoute.path) {
              <mat-expansion-panel class="third-level">
                <mat-expansion-panel-header>
                  <mat-panel-title class="menu-item">
                    <div class="item-container">
                      <mat-icon>{{ innerMainRoute.metaData.navIcon }}</mat-icon>
                      <h6 class="route-name">{{ innerMainRoute.metaData.navName }}</h6>
                    </div>
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <mat-nav-list>
                  @for (childRoute of innerMainRoute.children; track childRoute.path) {
                    <mat-list-item
                      class="menu-item"
                      [routerLink]="mainRoute.path + '/' + innerMainRoute.path + '/' + childRoute.path"
                      routerLinkActive="active-link"
                      (click)="toggleDrawer()"
                    >
                      <div class="item-container-third-child">
                        <h6 class="route-name">{{ childRoute.metaData.navName }}</h6>
                      </div>
                    </mat-list-item>
                  }
                </mat-nav-list>
              </mat-expansion-panel>
            }
          </mat-expansion-panel>
        }
      }
    </mat-accordion>
  </div>

</div>
